import { getWaferStatusColor, formatWaferStatus } from "@/components/shared/utils";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { MeasurementRequest } from "@/types/measurementRequest";
import { useMemo, useState } from "react";
import { Link } from "react-router";

export function WaferSection({ measurementRequest }: { measurementRequest: MeasurementRequest }) {
  const allWafers = measurementRequest.waferRequests;

  const initiallySelectedWafer = useMemo(() => {
    return allWafers[0]?._id ?? null;
  }, [allWafers]);

  const [selectedWafer, setSelectedWafer] = useState<number | null>(initiallySelectedWafer);

  const waferToDisplay = useMemo(() => {
    return allWafers.find((w) => w._id === selectedWafer);
  }, [allWafers, selectedWafer]);

  return (
    <Card className="w-full">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium">Wafers</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-4 gap-6">
          <div className="space-y-2">
            <div>
              <h3 className="font-medium mb-4 text-blue-600">
                <Link to={`/test-labels/${measurementRequest.testLabel.id}`}>
                  {measurementRequest.testLabel.name}
                </Link>
              </h3>
              {measurementRequest.waferRequests.map((wafer) => (
                <div
                  key={wafer._id}
                  className={`flex items-center justify-between p-2 rounded cursor-pointer transition-colors ${selectedWafer === wafer._id ? "bg-blue-50 border border-blue-200" : "hover:bg-gray-50"}`}
                  onClick={() => setSelectedWafer(wafer._id)}
                >
                  <span className="font-medium">{wafer.name}</span>
                  <Badge className={getWaferStatusColor(wafer.status)} variant="secondary">
                    {formatWaferStatus(wafer.status)}
                  </Badge>
                </div>
              ))}
            </div>
          </div>

          <div className="col-span-3 space-y-6">
            {waferToDisplay ? (
              <>
                <h3 className="text-lg font-semibold">Wafer {waferToDisplay.name}</h3>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <span className="text-xs text-muted-foreground">ChipPos</span>
                    <div className="font-medium">{waferToDisplay.chipPosName}</div>
                  </div>
                </div>
              </>
            ) : null}

            {/* <div className="grid grid-cols-3 gap-4">
                <div>
                  <span className="text-xs text-muted-foreground"># dies</span>
                  <p className="text-lg font-bold">15</p>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground">est. time per die (min)</span>
                  <p className="text-lg font-bold">20</p>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground">est. total</span>
                  <p className="text-lg font-bold">5hrs</p>
                </div>
              </div> */}

            {/* <div className="grid grid-cols-2 gap-4">
                <div>
                  <span className="text-xs text-muted-foreground">Measurement System</span>
                  <Button
                    variant="link"
                    className="p-0 h-auto font-medium text-blue-600"
                    onClick={() => navigate("/measurement-systems")}
                  >
                    NYX
                    <ExternalLink className="h-3 w-3 ml-1" />
                  </Button>
                </div>
                <div>
                  <span className="text-xs text-muted-foreground">Queue Order</span>
                  <p className="text-sm font-medium">#3</p>
                </div>
              </div> */}

            {/* <div>
                <h4 className="font-medium mb-2">Measurement report</h4>
                <div className="text-xs text-muted-foreground mb-2">Raw files | Report</div>
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" disabled className="opacity-50">
                    <Download className="h-3 w-3 mr-1" />
                    Download
                  </Button>
                  <Button variant="outline" size="sm" disabled className="opacity-50">
                    <ExternalLink className="h-3 w-3 mr-1" />
                    Link
                  </Button>
                </div>
              </div> */}

            {/* <div>
                <h4 className="font-medium mb-4">Status History</h4>
                <div className="space-y-3">
                  {[
                    {
                      timestamp: "15/05/2025 16:14",
                      user: "System",
                      status: "completed",
                      info: "All measurements completed successfully",
                    },
                    {
                      timestamp: "15/05/2025 14:30",
                      user: "Operator A",
                      status: "executing",
                      info: "Measurement sequence started",
                    },
                    {
                      timestamp: "14/05/2025 09:15",
                      user: "System",
                      status: "tf_completed",
                      info: "Test flight validation passed",
                    },
                    {
                      timestamp: "14/05/2025 08:45",
                      user: "Ilja Cooreman",
                      status: "tf_executing",
                      info: "Test flight initiated",
                    },
                    {
                      timestamp: "13/05/2025 16:20",
                      user: "System",
                      status: "tf_pending",
                      info: "Queued for test flight",
                    },
                    {
                      timestamp: "13/05/2025 14:10",
                      user: "Dr. Smith",
                      status: "planned",
                      info: "Request approved and scheduled",
                    },
                    {
                      timestamp: "13/05/2025 10:00",
                      user: "Dr. Smith",
                      status: "to_do",
                      info: "Initial request created",
                    },
                  ].map((entry, index) => (
                    <div key={index} className="flex items-start gap-4 p-3 bg-muted/30 rounded-lg">
                      <div className="flex-shrink-0 w-2 h-2 rounded-full bg-blue-500 mt-2"></div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between mb-1">
                          <Badge className={getStatusColor(entry.status)} variant="secondary">
                            {formatStatus(entry.status)}
                          </Badge>
                          <span className="text-xs text-muted-foreground">{entry.timestamp}</span>
                        </div>
                        <p className="text-sm font-medium">{entry.info}</p>
                        <p className="text-xs text-muted-foreground">by {entry.user}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div> */}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
